import axiosClient from './axiosClient'

const structureApi = {
  create: params => axiosClient.post('structures', params),
  getAll: () => axiosClient.get('structures'),
}

export default structureApi